module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "StreakCloudBackground.435a70fb.png";